import React, { useState } from 'react';

import SearchStart from '@/components/organisms/SearchStart/SearchStart';

const SearchStartPage: React.FC = () => {
  // Read params synchronously on first render — useSearchParams() in Pages Router
  // returns null on the initial render and only populates after router hydration,
  // causing isNative to flip false→true on the second render. That flip changes
  // SearchPageContainer's marginTop from 0→48px, making MultiSearch jump down.
  // window.location.search is available immediately (CSR-only app, no SSR).
  const [params] = useState<URLSearchParams>(() => {
    if (typeof window === 'undefined') return new URLSearchParams();
    return new URLSearchParams(window.location.search);
  });
  const query = params.get('q') || undefined;
  const isNative = params.get('isNative') === 'true';

  return <SearchStart query={query} isNative={isNative} />;
};

SearchStartPage.displayName = 'SearchStartPage';
export default SearchStartPage;
